import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { emptyPlatform, IPlatform } from '../../../model/platform';
import { PlatformService } from '../../../services/platform.service';
import { LoginService } from '../../../services/login.service';
import { ClientAdhesionService } from '../../../services/client-adhesion.service';
import { emptyClientAdhesionFilter, IClientAdhesionFilter } from '../../../model/client-adhesion-filter';
import { emptyClientAdhesionList, IClientAdhesionList } from '../../../model/client-adhesion-list';
import { IReceiver } from '../../../model/receiver';
import { emptyClientFilter, IClientFilter } from '../../../model/client-filter';
import { emptyIDireList, IDireList } from '../../../model/dire-list';
import { DireService } from '../../../services/dire.service';
import { Subject } from 'rxjs/Subject';
import { SpinnerService } from '../../../services/spinner.service';
import { IClientAdhesion } from '../../../model/client-adhesion';
import { ToastsManager } from 'ng2-toastr';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IHttpErrorsResponse } from '../../../model/http-errors-response';
import { RechargeDireService } from "../../../services/recharge-dire.service";
import { Subscription } from "rxjs";
import { ActivatedRoute, Params } from "@angular/router";

@Component({
  selector: 'app-inv-client-list',
  templateUrl: './inv-client-list.component.html',
  styleUrls: ['./inv-client-list.component.css']
})
export class InvClientListComponent implements OnInit {

  /**
   * listado de plataformas
   *
   * @type {IPlatform[]}
   */
  platforms: IPlatform[] = [];

  /**
   *
   * @type {IPlatform}
   */
  platform: IPlatform = emptyPlatform;

  /**
   * listado de autorizaciones de adhesion
   *
   * @type {IClientAdhesionList}
   */
  clientAdhesionList: IClientAdhesionList = emptyClientAdhesionList;

  /**
   *
   * @type {IClientAdhesionFilter}
   */
  filter: IClientAdhesionFilter = emptyClientAdhesionFilter;

  /**
   * Identificador de Invoicing Service
   */
  identifier: string;

  /**
   *
   * @type {IDireList}
   */
  direList: IDireList = emptyIDireList;

  /**
   *
   * @type {IClientFilter}
   */
  clientFilter: IClientFilter = emptyClientFilter;

  /**
   *
   * @type {boolean}
   */
  showDireUnits: boolean = false;

  /**
   *
   * @type {string}
   */
  searchedText: string = '';

  /**
   *
   * @type {Subject<any>}
   */
  subject: Subject<string> = new Subject();

  /**
   *
   * @type {number}
   */
  itemsPerPageAdhesion: number = 5;

  /**
   *
   * @type {number}
   */
  itemsPerPageDire: number = 5;

  /**
   *
   * @type {number}
   */
  pAdhesion: number = 0;

  /**
   *
   * @type {number}
   */
  pDire: number = 0;

  /**
   * Contenido del panel modal para actualizar un receiver
   */
  @ViewChild('updateClientAdhesion')
  updateClientAdhesion: TemplateRef<any>;

  /**
   * Errors
   */
  errors: IHttpErrorsResponse;

  /**
   * Contenido del panel modal de confirmación para asociar unidad a plataforma
   */
  @ViewChild('confirmAssociation')
  private confirmAssociation: TemplateRef<any>;


  /**
   * Indica si se selecciona o no todos los elementos
   * @type {boolean}
   */
  swSelectAll: boolean = false;

  subscriptionRecharge: Subscription;

  /**
   *
   * @param {PlatformService} platformService
   * @param {LoginService} loginService
   * @param {ClientAdhesionService} clientAdhesionService
   * @param {DireService} direService
   * @param {SpinnerService} spinnerService
   * @param {ToastsManager} toastr
   * @param {TranslateService} translate
   * @param {NgbModal} modalService
   * @param {RechargeDireService} rechargeDireService
   * @param {ActivatedRoute}  route
   */
  constructor(private platformService: PlatformService,
              private loginService: LoginService,
              private clientAdhesionService: ClientAdhesionService,
              private direService: DireService,
              private spinnerService: SpinnerService,
              private toastr: ToastsManager,
              private translate: TranslateService,
              private modalService: NgbModal,
              private rechargeDireService: RechargeDireService,
              private route: ActivatedRoute,) {
  }

  ngOnInit() {
    this.errors = null;
    this.route.params
      .subscribe((params: Params) => {
        this.identifier = params['identifier'];
        this.reloadList();
        this.platformService.getPlatforms(this.identifier)
          .subscribe(res => this.platforms = res);
      });

    this.subscriptionRecharge = this.rechargeDireService.rechargeInvoice$
      .subscribe(() => {
        this.getDireUnits();
      });
  }

  onSaveReceiverClicked() {
    this.showDireUnits ? this.saveReceiversFromDires() : this.saveReceiversFromAuthorizations();
  }

  /**
   *
   * @return {IReceiver[]}
   */
  getSelectedReceivers(): IReceiver[] {
    this.errors = null;
    return this.clientAdhesionList.items
      .filter(res => {
        return res.selected === true;
      }).map(res => {
        return {
          id: -1,
          platform: null,
          platformId: null,
          dire: res.dire,
          direCode: res.dire.code,
          status: '',
          selected: res.selected
        };
      });
  }

  /**
   *
   * @return {IReceiver[]}
   */
  getSelectedDiresAsReceivers(): IReceiver[] {
    this.errors = null;
    return this.direList.items
      .filter(res => {
        return res.selected === true;
      }).map(res => {
        return {
          id: -1,
          platform: null,
          platformId: null,
          dire: res,
          direCode: res.code,
          status: '',
          selected: res.selected
        };
      })
  }

  getInvoicingClientAdhesions() {
    this.errors = null;
    this.filter.dire = this.searchedText;
    console.log(this.identifier);
    this.clientAdhesionService.getInvoicingClientAdhesions(this.identifier, this.filter)
      .subscribe(res => {
        console.log(res);
        this.clientAdhesionList = res;
      });
  }

  /**
   *
   * @return {IReceiver[]}
   */
  getPlatformReceivers(): IReceiver[] {
    this.errors = null;
    return this.platform.receivers.map(res => {
      return {
        id: res.id,
        platform: null,
        platformId: null,
        dire: res.dire,
        direCode: res.dire.code,
        status: res.status,
        selected: false
      };
    });
  }

  onValueChange(value) {
    this.showDireUnits = value;
    this.showDireUnits ? this.onDireUnitsClicked() : this.onShowAuthorizationsClicked();
  }

  onDireUnitsClicked() {
    this.clearReceiversSelected();
    this.reloadList();
  }

  onShowAuthorizationsClicked() {
    this.clearDireUnitsSelected();
    this.reloadList();
  }

  saveReceiversFromAuthorizations() {
    this.platformService.updatePlatform(this.platform, this.mergeReceivers(this.getSelectedReceivers()), this.identifier)
      .subscribe(() => {
          this.reloadList();
          this.platformService.getPlatforms(this.identifier)
            .subscribe(res => this.platforms = res);
          this.translate.get("Unidad asociada correctamente").subscribe((res: string) => {
            this.toastr.info(res).then();
          });

        },
        error => {
          this.errors = error;
        });
  }

  saveReceiversFromDires() {
    this.platformService.updatePlatform(this.platform, this.mergeReceivers(this.getSelectedDiresAsReceivers()), this.identifier)
      .subscribe(() => {
          this.reloadList();
          this.platformService.getPlatforms(this.identifier)
              .subscribe(res => this.platforms = res);
          this.translate.get("Unidad asociada correctamente").subscribe((res: string) => {
            this.toastr.info(res).then();
          });
        },
        error => {
          this.errors = error;
        });
  }

  onKeyUp() {
    this.subject.next();
  }

  reloadList() {
    this.platform = null;
    this.swSelectAll = false;
    this.showDireUnits ? this.getDireUnits() : this.getInvoicingClientAdhesions();
  }

  getDireUnits() {
    this.spinnerService.setSpinner(true);
    this.clientFilter.searchedText = this.searchedText;
    this.clientFilter.isReceiver = 'n';
    this.direService.searchDireUnits(this.identifier, this.clientFilter)
      .subscribe(res => {
          this.spinnerService.setSpinner(false);
          this.direList = res;
        },
        () => (this.spinnerService.setSpinner(false)));
  }

  clearDireUnitsSelected() {
    this.errors = null;
    this.showDireUnits = false;
    this.direList.items.forEach(x => x.selected = false);
  }

  clearReceiversSelected() {
    this.errors = null;
    this.showDireUnits = true;
    this.clientFilter.isReceiver = 'n';
    this.clientAdhesionList.items.forEach(x => x.selected = false);
  }

  /**
   *
   * @param {IReceiver[]} selectedReceivers
   * @return {IReceiver[]}
   */
  mergeReceivers(selectedReceivers: IReceiver[]) {
    return this.getPlatformReceivers().concat(selectedReceivers);
  }

  /**
   *
   * @return {boolean | IReceiver[]}
   */
  isDataSelected() {
    return this.getSelectedDiresAsReceivers().length > 0 || this.getSelectedReceivers().length > 0;
  }

  /**
   *
   * @param {IClientAdhesion} clientAdhesion
   */
  updateInvoicingClientAdhesion(clientAdhesion: IClientAdhesion) {
    this.clientAdhesionService.updateInvoicingClientAdhesion(clientAdhesion, this.identifier)
      .subscribe(res => {
          this.clientAdhesionList.items = this.clientAdhesionList.items.filter(aux => aux.id !== res.id);
        },
        error => {
          this.translate.get(error).subscribe((res: string) => {
            this.toastr.warning(res).then();
          });
        });
  }

  onCancelClientAdhesionClicked(clientAdhesion: IClientAdhesion) {
    this.modalService.open(this.updateClientAdhesion).result.then((result) => {
      if (result === 'update') {
        this.updateInvoicingClientAdhesion(clientAdhesion);
      }
    })
  }

  /**
   * Abre el panel modal de confirmación de acción
   */
  openConfirmAssoc() {
    this.modalService.open(this.confirmAssociation).result.then((result) => {
      if (result === 'createAssoc') {
        this.onSaveReceiverClicked();
      }else{
        this.platform = null;
      }
    });
  }

  /**
   * Select/Deselect all receivers
   */
  onSelectAllClicked(): void {
    if (this.showDireUnits) {
      for (let dire of this.direList.items) {
        dire.selected = !this.swSelectAll;
      }
    } else {
      for (let clientAdhesion of this.clientAdhesionList.items) {
        clientAdhesion.selected = !this.swSelectAll;
      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/app-manager/invoicing-services/inv-client-list/inv-client-list.component.ts